import {
  getDebFilterRepo, getDebListingRepo , postDebListingLiveSyncRepo
} from "../repositories/newsletter"
import { createSlice } from "@reduxjs/toolkit";

const debListingSlice = createSlice({
    name: "debListingReducer",
    initialState: {
        debListingLoading: false,
        debListingData: null,
        debListingError: null,

        debCategoriesLoading :false,
        debCategoriesData : null,
        debCategoriesError:null,

        debTitleLoading :false,
        debTitleData :null,
        debTitleError:null,

        debAuthorLoading:false,
        debAuthorData:null,
        debAuthorError:null,


        debLiveSyncLoading:false,
        debLiveSyncData:null,
        debLiveSyncError:null,


     },

    reducers:{
        getDebListingLoading(state, action) {
            return {
                ...state,
                debListingLoading: true,
            };
        },
        getDebListingSuccess(state, action) {
            return {
                ...state,
                debListingLoading: false,
                debListingData: action.payload,
                
            };
        },
        getDebListingFailure(state, action) {
            return {
                ...state,
                debListingLoading: false,
                debListingError: action.payload,
                debListingData: null
            };
        },
        clearGetDebListingReponse(state, action) {//remove
            return {
                ...state,
                debListingData: null,
                debListingError: null,
            };
        },
        getDebCategoriesLoading(state, action) {
            return {
                ...state,
                debCategoriesLoading: true,
            };
        },
        getDebCategoriesSuccess(state, action) {
            return {
                ...state,
                debCategoriesLoading: false,
                debCategoriesData: action.payload,
            };
        },
        getDebCategoriesFailure(state, action) {
            return {
                ...state,
                debCategoriesLoading: false,
                debCategoriesError: action.payload,
            };
        },
        getDebTitleLoading(state, action) {
            return {
                ...state,
                debTitleLoading: true,
            };
        },
        getDebTitleSuccess(state, action) {
            return {
                ...state,
                debTitleLoading: false,
                debTitleData: action.payload,
            };
        },
        getDebTitleFailure(state, action) {
            return {
                ...state,
                debTitleLoading: false,
                debTitleError: action.payload,
            };
        },
        getDebAuthorLoading(state, action) {
            return {
                ...state,
                debAuthorLoading: true,
            };
        },
        getDebAuthorSuccess(state, action) {
            return {
                ...state,
                debAuthorLoading: false,
                debAuthorData: action.payload,
            };
        },
        getDebAuthorFailure(state, action) {
            return {
                ...state,
                debAuthorLoading: false,
                debAuthorError: action.payload,
            };
        },

        postDebLiveSyncLoading(state, action) {
            return {
                ...state,
                debLiveSyncLoading: true,
            };
        },
        postDebLiveSyncSuccess(state, action) {
            return {
                ...state,
                debLiveSyncLoading: false,
                debLiveSyncData: action.payload,
            };
        },
        postDebLiveSyncFailure(state, action) {
            return {
                ...state,
                debLiveSyncLoading: false,
                debLiveSyncError: action.payload,
            };
        },
        clearSyncUpdateReponse(state, action) {
            return {
                ...state,
                debLiveSyncData: null,
                debLiveSyncError: null,
            };
        },


    }
})
export const {
    getDebListingLoading,
    getDebListingSuccess,
    getDebListingFailure,
    clearGetDebListingReponse,

    getDebCategoriesLoading,
    getDebCategoriesSuccess,
    getDebCategoriesFailure,
    
    getDebTitleLoading,
    getDebTitleSuccess,
    getDebTitleFailure,
    

    getDebAuthorLoading,
    getDebAuthorSuccess,
    getDebAuthorFailure,

     postDebLiveSyncLoading,
     postDebLiveSyncSuccess,
     postDebLiveSyncFailure,

     clearSyncUpdateReponse,
    


} = debListingSlice.actions;

export const getdebListing = (params) => {
    return async (dispatch) => {
        dispatch(getDebListingLoading());
        await getDebListingRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getDebListingSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDebListingFailure(error.message));
                }
            });
    };
};


export const getdebFilterCategories = (params) => {
    return async (dispatch) => {
        dispatch(getDebCategoriesLoading());
        await getDebFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getDebCategoriesSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDebCategoriesFailure(error.response));
                }
            });
    };
};

export const getdebFilterTitle = (params) => {
    return async (dispatch) => {
        dispatch(getDebTitleLoading());
        await getDebFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getDebTitleSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDebTitleFailure(error.response));
                }
            });
    };
};
export const getdebFilterAuthor = (params) => {
    return async (dispatch) => {
        dispatch(getDebAuthorLoading());
        await getDebFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getDebAuthorSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDebAuthorFailure(error.response));
                }
            });
    };
};


export const postDebListingLiveSync = (params) => {
    console.log("caling 1 for laoding")
    return async (dispatch) => {
        dispatch(postDebLiveSyncLoading());
        await postDebListingLiveSyncRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    console.log("caling 2 if success")
                    dispatch(postDebLiveSyncSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    console.log("caling 2 if fail")
                    dispatch(postDebLiveSyncFailure(error.response));
                }
            });
    };
};
export default debListingSlice.reducer;